<template>
    <div class="card mb-3">
        <img style="display: none;" id='reportLogo' src='@/assets/report_logo.png' alt='Report Logo'>
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Date"><br>
                                <a-range-picker v-model="inputDate" format="MM-DD-YYYY" :placeholder="['Start Date', 'End Date']" style="width: 100%"/>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border: 0px; width: 20%" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border: 0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="'void_cancel_refund_report'">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click="clearJsonData"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" class="float-right"  style=" width: 20%;" name="void_cancel_refund_report.xls">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import reportUtils from '../../components/reportUtils'

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                JsonData: []
            }
        },

        mounted: async function() {
            var component_x = this;

            var userId = secureStorage.getItem('userId');
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem('defaultSiteId');
            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null);
            if (site != undefined) {
                this.site_type = site.site_type
            }
            this.inputSite = [siteId]
        },

        computed: {
            ...mapState(['endPoint']),
        },

        components: {
            VueJsonToCsv
        },

        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },

            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg
                });
            },

            sort(data) {
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },

            convertToCurrency(num) {
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },

            generateReport: async function() {
                if (this.inputDate.length == 0) {
                    this.openNotificationWithIcon('error', 'No records returned. Please make sure to check your filters.');
                    return
                }

                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date   = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                var void_cancel_returns = await HTTPRequest.getRequest(this.endPoint + 'void_cancel_refund?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date, null);

                if (void_cancel_returns.length > 0) {
                    let doc = new jsPDF({orientation: 'landscape', unit: 'mm', format: 'legal'});
                    let reportLogo = document.getElementById('reportLogo');
                    let titleY = 20
                    if (reportLogo) {
                        const width = reportLogo.naturalWidth || reportLogo.width
                        const height = reportLogo.naturalHeight || reportLogo.height
                        if (width && height) {
                            const scale = Math.min(30 / width, 15 / height)
                            const renderedHeight = height * scale
                            doc.addImage(reportLogo, 'PNG', 15, 2, width * scale, renderedHeight)
                            titleY = Math.max(titleY, renderedHeight + 8)
                        }
                    }

                    doc.setFontSize(14);
                    doc.setFontType("bold");
                    doc.text(15, titleY, "Void Cancel Refund Report")
                    doc.setFontType("normal");
                    doc.setFontSize(8);
                    doc.text(
                        15,
                        titleY + 5,
                        "From " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A') +
                        " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A')
                    )

                    const siteNames = this.inputSite.length
                        ? this.siteOptions
                            .filter(site => this.inputSite.some(id => String(id) === String(site.id)))
                            .map(site => site.name)
                            .join(', ')
                        : 'All Sites'
                    const filterDetails = doc.splitTextToSize('Sites: ' + siteNames, 325)
                    doc.text(15, titleY + 10, filterDetails)

                    const reportData = void_cancel_returns.map(row => [
                        row.DOCUMENT_DATE,
                        row.SITE,
                        row.TERMINAL,
                        row.ORDER_NUMBER,
                        row.PRODUCT_NAME,
                        row.TRANSACTION_TYPE,
                        row.STATUS,
                        row.PREPARED_STATUS,
                        row.REASON,
                        row.QUANTITY,
                        this.convertToCurrency(Number(row.PRICE)),
                        row.CASHIER_NAME,
                        row.MANAGER_CODE
                    ])
                    const totalQty = void_cancel_returns.reduce((total, row) => total + Number(row.QUANTITY), 0)
                    const totalAmount = void_cancel_returns.reduce((total, row) => total + Number(row.PRICE), 0)
                    reportData.push(['', '', '', '', '', '', '', '', 'Totals:', this.convertToCurrency(totalQty), this.convertToCurrency(totalAmount), '', ''])
                    const totalRowIndex = reportData.length - 1

                    doc.autoTable({
                        startY: titleY + 12 + filterDetails.length * 3,
                        head: [[
                            'Date', 'Site', 'Terminal', 'Order Number', 'Item', 'Type', 'Status', 'Prepared Status',
                            'Reason', 'Quantity', 'Gross', 'Entered By', 'Authorization'
                        ]],
                        body: reportData,
                        theme: 'grid',
                        rowPageBreak: 'avoid',
                        margin: { left: 15, right: 15, bottom: 15 },
                        styles: { fontSize: 7, cellPadding: 0.8, overflow: 'linebreak' },
                        headStyles: { fontSize: 7 },
                        columnStyles: {
                            0: { cellWidth: 34, overflow: 'hidden' },
                            1: { cellWidth: 23 },
                            2: { cellWidth: 30 },
                            3: { cellWidth: 18 },
                            4: { cellWidth: 49 },
                            5: { cellWidth: 19 },
                            6: { cellWidth: 18 },
                            7: { cellWidth: 20 },
                            8: { cellWidth: 27 },
                            9: { cellWidth: 13, halign: 'right' },
                            10: { cellWidth: 17, halign: 'right' },
                            11: { cellWidth: 31 },
                            12: { cellWidth: 26 }
                        },
                        didParseCell(data) {
                            if (data.row.section === 'body' && data.row.index === totalRowIndex) {
                                data.cell.styles.fontStyle = 'bold'
                            } else if (data.row.section === 'body' && (data.row.index + 1) % 5 === 0) {
                                data.cell.styles.fillColor = [240, 240, 240]
                            }
                        }
                    });

                    let printed_by = secureStorage.getItem("email") || ''
                    let pageCount = doc.internal.getNumberOfPages();
                    for(let i = 1; i <= pageCount; i++) { 
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "Void Cancel Refund Report", 340, 205, i, pageCount)
                    }

                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('error', 'No records returned. Please make sure to check your filters.');
                }
            }, 

            generateFile: async function() {
                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'No records returned. Please make sure to check your filters.');
                    return
                }

                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                
                let from_header = this.inputDate[0].format('MMMM DD, YYYY hh:mm A')
                let to_header = this.inputDate[1].format('MMMM DD, YYYY hh:mm A')

                var tenders = await HTTPRequest.getRequest(this.endPoint + 'void_cancel_refund?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date, null);
                if(tenders.length > 0){
                    let headers = [];
                    let site_specific = [];
                    let header_detail = [];
                    let total_amount = 0
                    let total_qty = 0
 
                    header_detail.push('Date', 'Site', 'Terminal', 'Order Number', 'Item', 'Type', 'Status', 'Prepared Status', 'Reason', 'Quantity', 'Gross', 'Entered By', 'Authorization')
                    headers = header_detail
                    let reportData = []
                    for(let i=0; i < tenders.length; i++){
                        let reportLine = tenders[i]

                        let detail = []
                        detail.push(
                            reportLine.DOCUMENT_DATE,
                            reportLine.SITE,
                            reportLine.TERMINAL,
                            reportLine.ORDER_NUMBER,
                            reportLine.PRODUCT_NAME,
                            reportLine.TRANSACTION_TYPE,
                            reportLine.STATUS,
                            reportLine.PREPARED_STATUS,
                            reportLine.REASON,
                            reportLine.QUANTITY,
                            reportLine.PRICE,
                            reportLine.CASHIER_NAME,
                            reportLine.MANAGER_CODE
                        )
                        reportData.push(Object.assign({}, detail))

                        total_amount += Number(reportLine.PRICE)
                        total_qty += Number(reportLine.QUANTITY)
                    }

                    let total_details = ['', '', '', '', '', '', '', '', 'Total :', total_qty, this.convertToCurrency(total_amount)]
                    reportData.push(Object.assign({}, total_details));

                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }

                    reportData.push([])
                    reportData.push(["Void, Cancel, Refund Report", "Generate By: " + printed_by,"From " + from_header + " to " + to_header])
                    reportData.push([])

                    let keys = headers;
                    let values = reportData;
                    var values_length = values.length;

                    let newJsonData = [];

                    for(var i = 0; i < values_length; i++){
                        var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                [val]: values[i][index]
                                }
                            )
                        )
                        );
                        newJsonData.push(result)
                    }

                    newJsonData.forEach(function(obj) {
                        for (var i in obj) {
                            if (obj[i] === undefined || obj[i] === null ) {
                                obj[i] = '';
                            }
                        }
                    });
                    site_specific.push(newJsonData)

                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('warning', 'Try increasing the scope by adjusting the filters.');
                }
            },

            clearJsonData() {
                this.JsonData = [];
            },
        }
    };
</script>
